export default __webpack_public_path__ + "static/media/Creativity.0e50a5c0.svg";